/**
 * Protected Route Component
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authService } from '../services/authApi';
import { buildLoginUrl, safeReturnPath } from '../utils/sessionExpiry';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Double-check: also verify token exists in localStorage
  const hasToken = authService.isAuthenticated();

  console.log('[ProtectedRoute] Auth check:', { isAuthenticated, loading, hasToken });

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect if either check fails
  if (!isAuthenticated || !hasToken) {
    console.log('[ProtectedRoute] Not authenticated, redirecting to login');
    // Carry the attempted path so re-login returns here (DOP-267).
    const returnTo = safeReturnPath(
      `${location.pathname}${location.search}${location.hash}`,
    );
    return <Navigate to={buildLoginUrl(returnTo)} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
